import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDAutoCompleteInput } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
  .nameOverride('title', {
    hidden: true,
  }, overrideReadOnly)
  .nameOverride('proposedScenarios', {
    _component: () => FDAutoCompleteInput,
    _customProps: {
      multiple: true,
      required: true,
      helperText: '',
      fullWidth: true,
    },
  }, overrideReadOnly);
